import React from 'react';

var JsonFormatter = function JsonFormatter(_ref) {
  var json = _ref.json,
      tabWith = _ref.tabWith,
      JsonStyle = _ref.JsonStyle;
  var jsonObject = JSON.parse(json);

  var repeatTabSpace = function repeatTabSpace(times) {
    var repeatedTabSpace = [];

    for (var i = 0; i < times; i++) {
      repeatedTabSpace.push( /*#__PURE__*/React.createElement("span", {
        style: JsonStyle.tabSpaceStyle,
        key: i
      }, '\xa0'.repeat(tabWith || 4)));
    }

    return repeatedTabSpace;
  };

  var TabSpaceRepeatTimes = 0;

  function categorize(data) {
    switch (Object.prototype.toString.call(data)) {
      case '[object Number]':
        {
          var dataJSX = /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.numberStyle
          }, data);
          return dataJSX;
        }

      case '[object String]':
        {
          var _dataJSX = /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.stringStyle
          }, "\"", data, "\"");

          return _dataJSX;
        }

      case '[object Boolean]':
        {
          var _dataJSX2 = data ? /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.booleanTrueStyle
          }, "true") : /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.booleanFalseStyle
          }, "false");

          return _dataJSX2;
        }

      case '[object Object]':
        {
          var _dataJSX3 = [];

          _dataJSX3.push( /*#__PURE__*/React.createElement(React.Fragment, {
            key: '{'
          }, /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.braceStyle
          }, '{'), /*#__PURE__*/React.createElement("br", null)));

          var keys = Object.keys(data);
          TabSpaceRepeatTimes++;

          for (var i in data) {
            _dataJSX3.push( /*#__PURE__*/React.createElement(React.Fragment, {
              key: i
            }, repeatTabSpace(TabSpaceRepeatTimes), /*#__PURE__*/React.createElement("span", {
              style: JsonStyle.propertyStyle
            }, "\"" + i + "\""), /*#__PURE__*/React.createElement("span", {
              style: JsonStyle.colonStyle
            }, ": "), categorize(data[i]), i === keys[keys.length - 1] ? null : /*#__PURE__*/React.createElement("span", {
              style: JsonStyle.commaStyle
            }, ","), /*#__PURE__*/React.createElement("br", null)));
          }

          TabSpaceRepeatTimes--;

          _dataJSX3.push( /*#__PURE__*/React.createElement(React.Fragment, {
            key: '}'
          }, repeatTabSpace(TabSpaceRepeatTimes), /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.braceStyle
          }, '}')));

          return _dataJSX3;
        }

      case '[object Array]':
        {
          var _dataJSX4 = [];

          _dataJSX4.push( /*#__PURE__*/React.createElement(React.Fragment, {
            key: "["
          }, /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.bracketStyle
          }, "["), /*#__PURE__*/React.createElement("br", null)));

          TabSpaceRepeatTimes++;

          for (var _i = 0; _i < data.length; _i++) {
            _dataJSX4.push( /*#__PURE__*/React.createElement(React.Fragment, {
              key: _i
            }, repeatTabSpace(TabSpaceRepeatTimes), categorize(data[_i]), _i === data.length - 1 ? null : /*#__PURE__*/React.createElement("span", {
              style: JsonStyle.commaStyle
            }, ","), /*#__PURE__*/React.createElement("br", null)));
          }

          TabSpaceRepeatTimes--;

          _dataJSX4.push( /*#__PURE__*/React.createElement(React.Fragment, {
            key: "]"
          }, repeatTabSpace(TabSpaceRepeatTimes), /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.bracketStyle
          }, "]")));

          return _dataJSX4;
        }

      case '[object Null]':
        {
          var _dataJSX5 = /*#__PURE__*/React.createElement("span", {
            style: JsonStyle.nullStyle
          }, "null");

          return _dataJSX5;
        }
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    style: JsonStyle.style
  }, /*#__PURE__*/React.createElement("div", null, categorize(jsonObject)));
};

export { JsonFormatter };